import faker from 'faker';

import { IMandatoryItemData } from '../tariff-mandatory-item.types';
import { createRange } from '@/utils/helpers';
import { MandatoryItem } from '../tariff-mandatory-item';

export function createRandomMandatoryItem(): IMandatoryItemData {
  return {
    id: faker.datatype.number(),
    item: faker.datatype.number().toString()
  };
}

export const mockMandatoryItemsData: IMandatoryItemData[] = createRange(
  5
).map(() => createRandomMandatoryItem());

export const mockMandatoryItems = mockMandatoryItemsData.map(
  data => new MandatoryItem(data)
);
